import { render, staticRenderFns } from "./RuleRecordDialog.vue?vue&type=template&id=3345e56d&scoped=true&"
import script from "./RuleRecordDialog.vue?vue&type=script&lang=js&"
export * from "./RuleRecordDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3345e56d",
  null
  
)

export default component.exports